import { z } from "zod";

import { CellId } from "../idTypeBrands.js";
import { SqlCellActiveTabLiteral } from "../sql/index.js";

export const BlockConfig = z.object({
  // This should include a field type Literal("SQL_CELL") which is nice because
  // we can narrow typing based on that, vs using guard because then we can add
  // new fields without old configs breaking.
  sqlCellId: CellId,
  chartCellId: CellId,
  activeTab: SqlCellActiveTabLiteral,
});
export type BlockConfig = z.infer<typeof BlockConfig>;
